<template>
  <div class="average_comparison">

    <!--Average Comparison like above and below average-->
    <div v-if="thisval > avgval" class="above_average">is above the industry average</div>
    <div v-else-if="thisval == avgval & thisval !=0 " class="same_average">is the same with the industry average</div>
    <div v-else-if="thisval < avgval" class="below_average">
       is below the industry average
    </div>
    <div v-else-if="thisval == '0'" class="not_calculated">
      Not calculated
    </div>
    <div v-else class="not_calculated">Not calculated</div>

    <span style="font-size: 9px">
      {{ global_datum["group_name"] }} industry avg. is
      <span v-if="thisdef == 'average_sentiment_score'">
        % {{ avgval * 100 }}</span
      >
      <span v-else>{{ avgval }}</span>
    </span>
  </div>
</template>
<script>
// import global_datum from "@/assets/analytics/global_stats_groupa.json"; //default
// import axios from "axios";
export default {
  data() {
    return {
      global_datum: null,
      avgval: null,
    };
  },
  props: {
    thisval: Number,
    thisdef: String,
    thisgroup: {
      type: String,
      default: "groupa",
    },
  },
  created() {
    this.global_datum = require(`@/assets/analytics/global_stats_${this.thisgroup}.json`);
    this.avgval = Math.round(this.global_datum[this.thisdef]);
  },
};
</script>

<style scoped>
.above_average {
  border-bottom: solid 3px rgb(42, 228, 32);
  font-size: 0.75em;
}
.below_average {
  border-bottom: solid 3px rgb(239, 15, 75);
  font-size: 0.75em;
}
.same_average, .not_calculated {
  border-bottom: solid 3px rgb(8, 8, 8);
  font-size: 0.76em;
}
</style>